import { Select } from "antd";
import { useMemo } from "react";
import { IOption } from "../../../types/Option";

type IntervalSelectorProps = {
  value: number;
  onSelect: (val: number) => void;
  removeDaily?: boolean;
};

export const IntervalSelector = ({
  value,
  onSelect,
  removeDaily,
}: IntervalSelectorProps) => {
  const options: IOption[] = useMemo(() => {
    const val = removeDaily ? [] : [{ value: 1, label: "Daily" }];

    return [
      ...val,
      { value: 2, label: "Monthly" },
      { value: 3, label: "Yearly" },
    ];
  }, [removeDaily]);

  return (
    <Select size="small" options={options} value={value} onSelect={onSelect} />
  );
};
